export enum SbHost {
    GatewayBaseUrl = 'GatewayBaseUrl',
    PrivateAssetBaseUrl = 'PrivateAssetBaseUrl',
    PeFundBaseUrl = 'PeFundBaseUrl',
    FormConfigBaseUrl = 'FormConfigBaseUrl',
    WidgetDataBaseUrl = 'WidgetDataBaseUrl',
    MockDataBaseUrl = 'MockDataBaseUrl',
    LayoutConfigurationBaseUrl = 'LayoutConfigurationBaseUrl',
    GlobalResourceBaseUrl = 'GlobalResourceBaseUrl',
    AdminBaseUrl = 'AdminBaseUrl',
    CategoriesBaseUrl = 'CategoriesBaseUrl',
    DocumentsBaseUrl = 'DocumentsBaseUrl',
    KeycloakUrl = 'KeycloakUrl',
    ConsumerBaseUrl = 'ConsumerBaseUrl',
    SecuritySearchServiceUrl = 'SecuritySearchServiceUrl',
    ClickhouseBaseUrl = 'ClickhouseBaseUrl'
}
